import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { NativeBeeChatViewModel } from './NativeBeeChatViewModel';
import { BeeChatModal } from './BeeChatModal';

export const NativeBeeChatModal: FC = () => {
    const vm = useInstance(NativeBeeChatViewModel);
    useSubscription(() => vm);
    const isOpen = vm.isOpen();

    return (
        <BeeChatModal
            isOpen={isOpen}
            onClose={vm.close}
        />
    );
};
